import requests from "../util";
import doRequest from "../util/provider";
import { ExcursionAdditionDTO } from "./dtos";
import IExcursion from "./IExcursion";

const EXCURSION_URL = "/excursion";

const excursionApi = {
  getExcursion: async (id: string): Promise<IExcursion> =>
    await doRequest.get(`${EXCURSION_URL}/${id}`),

  getAllExcursions: async (): Promise<IExcursion[]> =>
    await doRequest.get(EXCURSION_URL),

  searchExcursions: (searchTerm: string): Promise<IExcursion[]> =>
    doRequest.get(`${EXCURSION_URL}?searchTerm=${searchTerm}`),
  createExcursion: async (newExcursion: IExcursion): Promise<IExcursion> =>
    await doRequest.post(EXCURSION_URL, newExcursion),
  getExcursionsFromTitle: async (title: string): Promise<IExcursion[]> =>
    await requests.get(`${EXCURSION_URL}?title=${title}`),
  updateExcursion: async (
    id: string,
    updatedExcursion: Omit<IExcursion, "storeId">
  ): Promise<IExcursion> =>
    await doRequest.patch(`${EXCURSION_URL}/${id}`, updatedExcursion),

  deleteExcursion: async (id: string): Promise<void> =>
    await doRequest.delete(`${EXCURSION_URL}/${id}`),
  getExcursionsFromAStore: async (storeId: string): Promise<IExcursion[]> =>
    await doRequest.get(`${EXCURSION_URL}?storeId=${storeId}`),
};

export default excursionApi;
